import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { BLOG_POSTS } from '@/data/blog-posts';
import { BlogCard } from './BlogCard';

export const BlogSection: React.FC = () => {
  return (
    <section className="py-32 bg-zinc-50/50 overflow-hidden" id="blog">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8">
          <div className="max-w-2xl">
            <span className="text-sm font-bold text-black mb-4 block">The Journal</span>
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6 tracking-tight">
              <span className="text-neon-cyan">Insights into the</span> <br />
              <span className="text-zinc-400 italic">Physics Revolution</span>
            </h2>
            <p className="text-zinc-500 text-lg leading-relaxed">
              Deep dives into simulation theory, creator strategies, and the technical artistry behind Fun Circle Games.
            </p>
          </div>
          
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 text-black font-bold text-sm hover:gap-4 transition-all group"
          >
            Read more articles
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {BLOG_POSTS.slice(0, 2).map((post, idx) => (
            <BlogCard key={post.id} post={post} index={idx} />
          ))}
        </div>
      </div>
    </section>
  );
};
